import { createContext, useContext, type ReactNode } from 'react';

import { fetchMicroSurveyGateway } from '../api/fetchMicroSurveyGateway';
import type { MicroSurveyGateway } from '../ports/microSurveyGateway';

/**
 * Which backend the micro survey hook talks to. It defaults to the real one, so
 * the app mounts no provider; a test mounts one holding an in-memory gateway.
 */
const MicroSurveyGatewayContext = createContext<MicroSurveyGateway>(fetchMicroSurveyGateway);

export function MicroSurveyGatewayProvider({
  gateway,
  children,
}: {
  gateway: MicroSurveyGateway;
  children: ReactNode;
}) {
  return (
    <MicroSurveyGatewayContext.Provider value={gateway}>
      {children}
    </MicroSurveyGatewayContext.Provider>
  );
}

export function useMicroSurveyGateway() {
  return useContext(MicroSurveyGatewayContext);
}
